import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import './registerServiceWorker'
import router from './router'
import { TroisJSVuePlugin } from 'troisjs';

createApp(App).use(router).use(vuetify).use(TroisJSVuePlugin).mount('#app')
